// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__yHeq6","title":"styles_title__8GkXD","list":"styles_list__JzXYU"};
module.exports.__checksum = "544c2610c4a7"